export const ONBOARDING_OG_IMAGE_PATH = '/og/neneOG4.jpg';
export const ONBOARDING_OG_IMAGE_URL = `https://innerbloomjourney.org${ONBOARDING_OG_IMAGE_PATH}`;
export const ONBOARDING_OG_IMAGE_TYPE = 'image/jpeg';
export const ONBOARDING_OG_IMAGE_WIDTH = '1200';
export const ONBOARDING_OG_IMAGE_HEIGHT = '630';
export const ONBOARDING_CANONICAL_URL = 'https://innerbloomjourney.org/onboarding';
